module.exports = __webpack_public_path__ + "static/img/lxfs.6f14fe3d.png";